
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import zhCN from 'ant-design-vue/es/date-picker/locale/zh_CN';
var request = require('request');
import UploadFile from '@/component/upload-file.vue';
import XLSX from 'xlsx';

const _ = {
  xorBy: require('lodash/xorBy')
};
const dateFormat = require('bmh/date-format');
const getUrl = require('baimahu/url-with-param');
const Hundun = namespace('Hundun');
const { VUE_APP_FCAPI: FCAPI } = process.env;
import client from 'baimahu/client';
import { Select } from 'ant-design-vue';
const API = {
  export_data: `${FCAPI}/boss/hundun/work/temporary`,
  delete_user: `${FCAPI}/boss/hundun/work/temporary/user`,
  change_log: `${FCAPI}/boss/hundun/user/log`,
  edit_user_detail: `${FCAPI}/boss/hundun/user/attribute`,
  get_list: `${FCAPI}/boss/hundun/work/temporary`,
  delete_tag: `${FCAPI}/boss/hundun/user/tag`,
  more_change: `${FCAPI}/boss/hundun/user/batch/0`,
  teacher_get_list: `${FCAPI}/boss/hundun/setting/teacher/search`,
  tag_get_list: `${FCAPI}/boss/hundun/setting/tag/search`,
  user_import: `${FCAPI}/boss/hundun/work/temporary/user`,
  edit_remark: `${FCAPI}/boss/hundun/work/temporary/user/attribute`,
  edit_custom: `${FCAPI}/boss/hundun/work/temporary/user/custom`,
  custom_list: `${FCAPI}/boss/hundun/work/temporary/custom`,
  mark_batch: `${FCAPI}/boss/hundun/work/temporary/mark/batch`,
  product_menu: `${FCAPI}/boss/setting/auth/product/menu`,
  more_changes: `${FCAPI}/boss/hundun/work/temporary/user/batch/0`,
  temporary: `${FCAPI}/boss/hundun/work/temporary/entity`,
  add_description_number: `${FCAPI}/boss/hundun/work/temporary/descriptionnumber`,
  sync_remark: `${FCAPI}/boss/hundun/work/temporary/sync`
};
interface from {
  charge_teacher_id: number[];
  follow_status: string;
  status: number;
  mobile: string;
  branch_id: number;
  teacher_id: number;
  name: string;
  entered_time: number[];
  expired_time_start: number[];
  tag_id: number[];
  tag_id_chuang: number[];
}
function initForm() {
  return {
    mobile: '',
    charge_teacher_id: [],
    follow_status: '0',
    status: 0,
    branch_id: 0,
    name: '',
    teacher_id: 0,
    entered_time: [],
    expired_time: [],
    create_time: [],
    description: '',
    description2: '',
    description3: '',
    description4: '',
    description5: '',
    tag_id: [0],
    tag_id_chuang: [0],
    tag_id_ai: [0],
    online_status: 0,
    adress: '',
    gift: '',
    is_activity: 0,
    tag_logic: 'or',
    corp_name: ''
  };
}
@Component({
  components: { UploadFile }
})
export default class MissionDetail extends Vue {
  /* eslint-disable */
  // @ts-ignore
  @Hundun.State('follow_status') follow_status: any; //跟进状态选项
  // @ts-ignore
  @Hundun.State('online_student_status') online_student_status: any; // 线上学籍选项
  // @ts-ignore
  @Hundun.State('tag_list') tag_list: any; //标签
  // @ts-ignore
  @Hundun.State('teacher_list') teacher_list: any; //负责班主任
  // @ts-ignore
  @Hundun.State('branch_office') branch_office: any; //分社选项
  /* eslint-enable */
  get teacher_widthout_all() {
    let s = [...this.teacher_list];
    s.pop();
    return s.slice(1);
  }
  get teacher_with_none() {
    let s = [...this.teacher_list];
    return s.slice(1);
  }
  get follow_status_without_all() {
    let s = [...this.follow_status];
    s.pop();
    return s.slice(1);
  }
  more_change = [
    {
      id: 1,
      value: '负责班主任'
    },
    {
      id: 2,
      value: '班主任'
    },
    {
      id: 3,
      value: '跟进状态'
    },
    {
      id: 4,
      value: '已处理'
    }
  ];
  title = ''; //临时任务名称
  delete_id = 1;
  confirm_delete = false; //确认删除弹框
  content = '';
  locale = zhCN;
  mission_id = 0;
  first = 0; //批量修改1级标志位
  more_list = []; //批量修改二级选择框
  more_form: any; //批量修改表单
  id = 0; //已处理的用户id
  select_row_data: any = [];
  log: string[] = []; //班主任备注
  tag_value = []; //标签value
  user: any = {}; //添加标签的用户信息
  show_change_modal = false; //批量修改弹框
  is_loading = false;
  show_confirm_modal = false; //确认已处理弹框
  show_confirm = false; //确认已处理弹框
  form = initForm();
  show_add_tag = false;
  table_data: any = {};
  select_row_key: any = []; //被选中项
  select_row_key_id: any = []; //被选中项
  teacher_table_data: any = []; // 负责班主任列表
  tag_table_data: any = []; // 标签列表
  ai_tag_list: any = []; //智能标签
  is_show_importModal = false; // 录入弹窗
  import_form: any;
  import_textarea = '';
  import_textarea2 = '';
  is_show_remarkModal = false; // 编辑备注1弹窗
  is_show_remarkModal2 = false; // 编辑备注2弹窗
  remark_data: any = {};
  remark_data2: any = {};
  remark_val = '';
  remark_val2 = '';
  is_select_all = false;
  is_show_feildsModal = false; //自定义字段弹窗
  feilds_form: any;
  choose_list_item: any = {};
  custom_list: any[] = [];
  is_show_waring_select_all = false;
  is_show_tag_teacherDetail = false;
  window = window as any;
  teacher_table_data_change = []; //批量修改里的班主任名单
  menu_type = []; // 获取menu的
  user_list_id = '';
  description_number = 0;
  edit_remark_title = '';
  remark_type = 0;
  custom_more_change_list = [] as any[];
  upload_visible = false;
  is_check_header = true;
  tag_type = 0;
  header = {
    A1: { v: '用户名' },
    B1: { v: '手机号' },
    C1: { v: '任务备注1' },
    D1: { v: '任务备注2' },
    E1: { v: '任务备注3' },
    F1: { v: '任务备注4' },
    G1: { v: '任务备注5' }
  };
  upload_file = [];

  is_show_description_modal = false;
  description: any = {
    is_new: false,
    sync_number: 0,
  };
  temporary: any = {};

  confirmDescription() {
    if (this.description.is_new) {
      this.addRemark();
      return;
    }

    if (this.description.sync_number > 0) {
      this.$confirm({
        title: '操作确认',
        content: `选择将{任务备注${this.description.sync_number}}同步至用户详情，操作后不可撤回，请确认。`,
        onOk: () => {
          this.syncRemark();
        }
      });
    } else {
      this.syncRemark();
    }  
  }

  async syncRemark() {
    const res = await this.$axios.put(API.sync_remark + '/' + this.mission_id, {
      description: this.temporary.description,
      sync_number: this.description.sync_number
    });
    if (res.status != 200) {
      return this.$message.error('提交失败！');
    }
    if (res.data.status != 200) {
      return this.$message.error(res.data.message);
    }
    this.$message.success('提交成功！');
    this.getTemporary();
    this.search(this.table_data.current);
    this.is_show_description_modal = false;    
  }

  formatCostom(id: number) {
    const data = this.custom_list.filter((item: any) => {
      return item.id === id;
    });
    return data.length ? data[0] : {};
  }
  // lee-添加用户名的验证----------------------------
  checkName() {
    const name = this.import_form.getFieldValue('name');
    if (name.length > 16) {
      return false;
    }
  }

  checkPhone() {
    const phone = this.import_form.getFieldValue('phone');
    if (phone) {
      return /^1[3456789]\d{9}$/.test(phone);
    } else {
      return false;
    }
  }
  selectAll() {
    if (this.is_select_all) {
      this.is_show_waring_select_all = true;
    } else {
      this.select_row_key = [];
    }
  }
  confirmSelectAll() {
    this.select_row_key = this.table_data.detail.map((item: any) => item.user_id);
    console.log('this.select_row_key', this.select_row_key);
    this.is_show_waring_select_all = false;
  }
  filterOption(input: any, option: any) {
    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  }
  getTagId() {
    const tag_arr: any[] = [];
    if (this.form.tag_id) {
      this.form.tag_id.forEach((element: any) => {
        tag_arr.push(element[element.length - 1]);
      });
    }
    if (this.form.tag_id_chuang) {
      this.form.tag_id_chuang.forEach((element: any) => {
        tag_arr.push(element[element.length - 1]);
      });
    }
    if (this.form.tag_id_ai) {
      this.form.tag_id_ai.forEach((element: any) => {
        tag_arr.push(element[element.length - 1]);
      });
    }

    return Array.from(new Set(tag_arr.filter(Boolean))).join(',');
  }
  async exportData() {
    const entered_time_start = this.form.entered_time[0] ? Math.floor((this.form.entered_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const entered_time_end = this.form.entered_time[1] ? Math.floor((this.form.entered_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const expired_time_start = this.form.expired_time[0] ? Math.floor((this.form.expired_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const expired_time_end = this.form.expired_time[1] ? Math.floor((this.form.expired_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const create_time_start = this.form.create_time[0] ? Math.floor((this.form.create_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const create_time_end = this.form.create_time[1] ? Math.floor((this.form.create_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';

    const custom_list_data = this.custom_list
      .filter((item: any) => item.value && item.value !== '全部')
      .map((item: any) => {
        if (item.type == 2) {
          return {
            id: item.id,
            value: item.value.toString(),
            type: 'select'
          };
        } else {
          return {
            id: item.id,
            value: item.value,
            type: 'text'
          };
        }
      });

    const send_data = {
      mobile: this.form.mobile ? this.form.mobile : '',
      charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      status: this.form.status === 0 ? '' : this.form.status,
      branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
      entered_time_start,
      entered_time_end,
      expired_time_start,
      expired_time_end,
      create_time_start,
      create_time_end,
      description: this.form.description,
      description2: this.form.description2,
      description3: this.form.description3,
      description4: this.form.description4,
      description5: this.form.description5,
      name: this.form.name,
      online_status: this.form.online_status,
      is_export: 1,
      teacher_id: this.form.teacher_id === 0 ? '' : this.form.teacher_id,
      tag_id: this.getTagId(),
      custom_list: encodeURIComponent(JSON.stringify(custom_list_data)),
      tag_logic: this.form.tag_logic, 
      corp_name: this.form.corp_name,
      // lee- 添加任务备注1和任务备注2
    };
    const url = getUrl(`${API.export_data}/${this.$route.params.id}`, send_data);
    const res: any = await this.$axios.get(url);
    if (res.data.status === 200) {
      this.$message.info(res.data.message);
    } else {
      window.location.href = url;
    }
  }
  async search(page = 1) {
    const entered_time_start = this.form.entered_time[0] ? Math.floor((this.form.entered_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const entered_time_end = this.form.entered_time[1] ? Math.floor((this.form.entered_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const expired_time_start = this.form.expired_time[0] ? Math.floor((this.form.expired_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const expired_time_end = this.form.expired_time[1] ? Math.floor((this.form.expired_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    const create_time_start = this.form.create_time[0] ? Math.floor((this.form.create_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
    const create_time_end = this.form.create_time[1] ? Math.floor((this.form.create_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
    this.is_loading = true;
    const custom_list_data = this.custom_list
      .filter((item: any) => item.value && item.value !== '全部')
      .map((item: any) => {
        if (item.type == 2) {
          return { id: item.id, value: item.value.toString(), type: 'select' };
        } else {
          return { id: item.id, value: item.value, type: 'text' };
        }
      })
      .filter((item: any) => item.value != '全部' && item.value != '');

    const send_data = {
      mobile: this.form.mobile ? this.form.mobile : '',
      charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
      follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
      status: this.form.status === 0 ? '' : this.form.status,
      current: page,
      branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
      page: 20,
      entered_time_start,
      entered_time_end,
      expired_time_start,
      expired_time_end,
      create_time_start,
      create_time_end,
      description: this.form.description,
      description2: this.form.description2,
      description3: this.form.description3,
      description4: this.form.description4,
      description5: this.form.description5,
      name: this.form.name,
      teacher_id: this.form.teacher_id === 0 ? '' : this.form.teacher_id,
      online_status: this.form.online_status,
      tag_id: this.getTagId(),
      custom_list: encodeURIComponent(JSON.stringify(custom_list_data)),
      tag_logic: this.form.tag_logic,
      corp_name: this.form.corp_name,
    };
    const url = getUrl(`${API.get_list}/${this.mission_id}`, send_data);
    // var xhr = new XMLHttpRequest();
    // xhr.open('GET', url, true);
    // xhr.send(`${send_data2}`);
    // xhr.onload = function () {
    //   console.log('123')
    // };
    // const res: any = await this.$axios.request({
    //   url: url,
    //   method: 'get',
    //   data: {id: 4, value: '23'}
    // });
    // if (res.data.data) {
    //   res.data.data.detail.forEach((item: any) => {
    //     item.custom.forEach((custom_item: any) => {
    //       const filter_item = this.custom_list.filter((custom_items: any) => custom_item.custom_name_id === custom_items.id)
    //     });
    //   });
    // }
    // console.log(request);
    // const res: any = request({
    //   url: url,
    //   method: 'GET',
    //   json: true,
    //   headers: {
    //     "content-type": "application/json",
    //   },
    //   body: {
    //     custom_list: this.custom_list,
    //   }
    // })
    const res: any = await this.$axios({
      method: 'get',
      url: url
    });
    if (res.status === 200) {
      if (res.data.data) {
        res.data.data.detail.forEach((item: any) => {
          const custom_data: any[] = [];
          this.custom_list.forEach((custom_item: any) => {
            custom_data.push({
              custom_name_id: custom_item.id,
              custom_value: undefined
            });
            // const filter_item = item.custom.filter((custom_items: any) => custom_item.id === custom_items.custom_name_id);
            // if (!filter_item.length) {
            //   item.custom = [...item.custom, {
            //     custom_name_id: custom_item.id,
            //     custom_value: undefined,
            //   }]
            // }
          });
          for (let i = 0; i < custom_data.length; i++) {
            item.custom.forEach((item: any) => {
              if (item.custom_name_id === custom_data[i].custom_name_id) {
                custom_data[i] = { ...custom_data[i], ...item };
              }
            });
          }
          item.custom = custom_data;
        });
      }
      this.table_data = res.data.data ? res.data.data : [];
      this.is_loading = false;
    } else {
      this.$message.error('获取失败');
      this.is_loading = false;
    }
    this.select_row_key = [];
    this.is_select_all = false;
  }
  changeMoretype(value: any) {
    this.more_form.resetFields();
    this.first = value;
    switch (value) {
      case 1: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 2: {
        this.more_list = this.teacher_list.slice(1);
        this.more_list.pop();
        break;
      }
      case 3: {
        this.more_list = this.follow_status.slice(1);
        this.more_list.pop();
        break;
      }
      default:
        break;
    }
  }
  //删除临时任务
  deleteMission(id: any) {
    this.delete_id = id;
    this.confirm_delete = true;
  }
  async confirmDelete() {
    const res: any = await this.$axios.delete(`${API.delete_user}/${this.delete_id}?menu_id=${(window as any).route_menu_id}`);
    if (res.status === 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
    } else {
      this.$message.error('删除失败');
    }
    this.confirm_delete = false;
  }
  //确认批量修改
  // confirmMoreChange() {
  //   this.more_form.validateFields((err: any, values: any) => {
  //     if (!err) {
  //       switch (this.first) {
  //         case 1:
  //           this.moreChange(this.select_row_key, 'charge_teacher_id', values.second);
  //           break;
  //         case 2:
  //           this.moreChange(this.select_row_key, 'teacher_id', values.second);
  //           break;
  //         case 3:
  //           this.moreChange(this.select_row_key, 'follow_status', values.second);
  //           break;
  //         case 4: {
  //           this.moreUserChange();
  //           this.show_change_modal = false;
  //           break;
  //         }
  //         default:
  //           break;
  //       }
  //       this.show_change_modal = false;
  //       this.select_row_key = [];
  //     }
  //   });
  // }
  // moreChangeProcessed() {
  //   this.more_form.validateFields((err: any, values: any) => {
  //     if (!err) {
  //       for (let item in values) {
  //         if (values[item] === undefined) {
  //           values[item] = null;
  //         }
  //       }
  //       this.moreChange(this.select_row_key, values['teacher'], values['teacher2'], values['status'], values['processed']);
  //       this.select_row_key = [];
  //     }
  //   });
  // }
  confirmMoreChange() {
    for (let i = 0; i < this.select_row_data.length; i++) {
      const id: any = this.select_row_data[i].id;
      this.select_row_key_id.push(id);
    }
    if (this.is_select_all === false) {
      this.more_form.validateFields((err: any, values: any) => {
        if (!err) {
          for (let item in values) {
            if (values[item] === undefined) {
              values[item] = null;
            }
          }
          // if (values['processed'] === 2) {
          //   this.show_confirm = true;
          // } else {
          //   this.moreChange(this.select_row_key, values['teacher'], values['teacher2'], values['status'], values['processed']);
          //   this.select_row_key = [];
          // }
          this.moreChange(this.select_row_key, this.select_row_key_id, values['teacher'], values['teacher2'], values['status'], values['processed']);
          this.select_row_key = [];
          this.select_row_key_id = [];
        }
        //   switch (this.first) {
        //     case 1:
        //       this.moreChange(this.select_row_key, 'charge_teacher_id', values.second);
        //       break;
        //     case 2:
        //       this.moreChange(this.select_row_key, 'teacher_id', values.second);
        //       break;
        //     case 3:
        //       this.moreChange(this.select_row_key, 'follow_status', values.second);
        //       break;
        //     case 4: {
        //       this.moreUserChange();
        //       this.show_change_modal = false;
        //       break;
        //     }
        //     default:
        //       break;
        //   }
        //   this.show_change_modal = false;
        //   this.select_row_key = [];
        // }
      });
    } else {
      this.show_confirm = false;
      this.show_confirm_modal = true;
    }
  }
  async moreChange(user_id: any, id: any, column_teacher: string, column_teacher2: string, column_status: string, coulmn_processed: string) {
    const custom = this.custom_more_change_list.map((item: any) => ({ custom_name_id: item.id, custom_value: item.value || undefined }));
    const send_data = {
      id: id,
      user_id: user_id,
      charge_teacher_id: column_teacher,
      teacher_id: column_teacher2,
      follow_status: column_status,
      status: coulmn_processed,
      custom: custom.filter((item: any) => item.custom_value)
    };
    await this.$axios.put(`${API.more_changes}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.select_row_key = [];
    this.is_select_all = false;
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
    this.custom_more_change_list.forEach((item) => (item.value = undefined));
    this.show_change_modal = false;
    this.show_confirm = false;
  }

  // async moreChange(id: any, column: string, value: any) {
  //   const send_data = {
  //     id: id,
  //     column: column,
  //     value: value
  //   };
  //   await this.$axios.put(API.more_change, send_data);
  //   this.select_row_key = [];
  //   this.is_select_all = false;
  //   this.search(this.table_data.current);
  //   this.$message.success('编辑成功');
  // }

  // 分页
  paginationOption(remote: any) {
    return {
      current: +remote.current || 0,
      total: remote.total || 0,
      pageSize: remote.limit || 0,
      showTotal: () => `共${remote.total}条，每页${remote.limit}条`
    };
  }
  changePage(page: any) {
    this.search(page.current);
  }
  showChangeModal() {
    if (this.select_row_key.length === 0) {
      this.$message.error('请先勾选要修改的用户');
      return;
    }
    this.content = '标记已处理后,对应处理状态将改为已处理';
    this.show_change_modal = true;
  }
  async confirmProcessing(id: any, user_id: any, record: any) {
    const arr_id: any = [id];
    const arr_user_id: any = [user_id];
    const send_data = {
      id: arr_id,
      user_id: arr_user_id,
      status: 2
    };
    const res = await this.$axios.put(`${API.more_changes}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
  }

  //确认已处理
  async confirmOperate(id: any, id_str: any) {
    // console.log(this.is_select_all);
    let res: any;
    if (this.is_select_all) {
      const entered_time_start = this.form.entered_time[0] ? Math.floor((this.form.entered_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const entered_time_end = this.form.entered_time[1] ? Math.floor((this.form.entered_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
      const expired_time_start = this.form.expired_time[0] ? Math.floor((this.form.expired_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const expired_time_end = this.form.expired_time[1] ? Math.floor((this.form.expired_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
      const create_time_start = this.form.create_time[0] ? Math.floor((this.form.create_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const create_time_end = this.form.create_time[1] ? Math.floor((this.form.create_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 86400 : '';
      this.is_loading = true;
      const send_data = {
        mobile: this.form.mobile ? this.form.mobile : '',
        charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
        follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
        status: this.form.status === 0 ? '' : this.form.status,
        current: 1,
        branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
        page: 20,
        entered_time_start,
        entered_time_end,
        expired_time_start,
        expired_time_end,
        create_time_start,
        create_time_end,
        description: this.form.description,
        description2: this.form.description2,
        name: this.form.name,
        teacher_id: this.form.teacher_id === 0 ? '' : this.form.teacher_id,
        tag_id: this.form.tag_id[this.form.tag_id.length - 1] === 0 ? '' : this.form.tag_id[this.form.tag_id.length - 1]
      };
      console.log(id);
      console.log(id_str);

      res = await this.$axios.put(`${API.mark_batch}/${this.$route.params.id}`, send_data);
      console.log(res);
      this.show_change_modal = false;
      this.show_confirm_modal = false;
      this.is_loading = false;
    } else {
      const res: any = await this.$axios.put(`${API.delete_user}/${id}?menu_id=${(window as any).route_menu_id}`, {
        status: 2,
        id_str: '' + id_str
      });
    }
    if (res.data.status === 200) {
      this.$message.success('处理成功');
      this.search(this.table_data.current);
    }
  }
  //编辑
  async editDetail(column: string, value: any, record: any) {
    if (column === 'cooperation' && value.length === 1) {
      //合作如果是1级则二级放空
      value.push('');
    }
    const send_data = {
      column: column,
      value: value
    };
    await this.$axios.put(`${API.edit_user_detail}/${record.user_id}?menu_id=${(window as any).route_menu_id}`, send_data);
    this.search(this.table_data.current);
    this.$message.success('编辑成功');
  }
  //添加标签
  addTag(record: any, type: number) {
    this.user = record;
    this.tag_value = [];
    this.show_add_tag = true;
    this.tag_type = type;
  }
  async moreUserChange() {
    let res: any;
    if (this.is_select_all) {
      const entered_time_start = this.form.entered_time[0] ? Math.floor((this.form.entered_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const entered_time_end = this.form.entered_time[1] ? Math.floor((this.form.entered_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
      const expired_time_start = this.form.expired_time[0] ? Math.floor((this.form.expired_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const expired_time_end = this.form.expired_time[1] ? Math.floor((this.form.expired_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
      const create_time_start = this.form.create_time[0] ? Math.floor((this.form.create_time[0] as any).hours(0).minutes(0).seconds(0) / 1000) : '';
      const create_time_end = this.form.create_time[1] ? Math.floor((this.form.create_time[1] as any).hours(23).minutes(59).seconds(59) / 1000) + 1 : '';
      this.is_loading = true;
      const send_data = {
        mobile: this.form.mobile ? this.form.mobile : '',
        charge_teacher_id: this.form.charge_teacher_id.length !== 0 ? this.form.charge_teacher_id.join(',') : '',
        follow_status: this.form.follow_status === '0' ? '' : this.form.follow_status,
        status: this.form.status === 0 ? '' : this.form.status,
        current: 1,
        branch_id: this.form.branch_id === 0 ? '' : this.form.branch_id,
        page: 20,
        entered_time_start,
        entered_time_end,
        expired_time_start,
        expired_time_end,
        create_time_start,
        create_time_end,
        description: this.form.description,
        description2: this.form.description2,
        name: this.form.name,
        teacher_id: this.form.teacher_id === 0 ? '' : this.form.teacher_id,
        tag_id: this.form.tag_id[this.form.tag_id.length - 1] === 0 ? '' : this.form.tag_id[this.form.tag_id.length - 1]
      };
      res = await this.$axios.put(`${API.mark_batch}/${this.$route.params.id}`, send_data);
    } else {
      const id_list = this.select_row_data.map((item: any) => item.id);
      const res: any = await this.$axios.put(`${API.delete_user}/${+this.$route.params.id}?menu_id=${(window as any).route_menu_id}`, { status: 2, id_str: id_list.join(',') });
    }
    if (res.status === 200) {
      this.$message.success('修改成功');
      this.search(this.table_data.current);
    }
    // if (res.data.status === 200) {
    //   this.$message.success('修改成功');
    //   this.search(this.table_data.current);
    // }
  }
  //确认添加标签
  confirmAdd() {
    const value = this.tag_value.pop();
    this.editDetail('tag', value, this.user);
    this.show_add_tag = false;
  }
  //查看
  check(record: any) {
    this.$router.push(`/hundun/user-detail/${record.user_id}?menu_id=${(window as any).route_menu_id}`);
    console.log(record);
  }
  //删除标签
  async deleteTag(id: number) {
    // this.is_loading = true;
    const res: any = await this.$axios.delete(`${API.delete_tag}/${id}?menu_id=${(window as any).route_menu_id}`);
    if (res.status == 200) {
      this.$message.success('删除成功');
      this.search(this.table_data.current);
      return;
    }
    // this.is_loading = false;
  }
  //添加备注
  async addLog(id: any, index: number) {
    //修改班主任备注
    if (!this.log[index]) {
      return;
    }
    const send_data = {
      user_id: id,
      content: this.log[index]
    };
    const res: any = await this.$axios.post(`${API.change_log}?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.status == 200) {
      this.$message.success('提交成功');
      this.search(this.table_data.current);
      this.log[index] = '';
    }
  }
  clearForm() {
    this.is_select_all = false;
    this.custom_list.forEach((item: any) => {
      item.value = item.type === 2 ? '全部' : '';
    });
    this.form = initForm();
  }
  onSelectChange(select_row_key: any, value: any) {
    this.select_row_data = value;
    //选择钩子函数
    this.select_row_key = select_row_key;
  }
  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d ');
  }
  showImportModal() {
    this.is_show_importModal = true;
    this.import_form.resetFields();
    this.import_textarea = '';
    this.import_textarea2 = '';
  }
  confirmImportData() {
    this.import_form.validateFields(async (err: any, values: any) => {
      if (!err) {
        console.log(this.import_form.getFieldsValue());
        const res = await this.$axios.post(API.user_import, {
          temporary_id: this.$route.params.id,
          mobile: this.import_form.getFieldsValue().phone,
          description: this.import_textarea,
          description2: this.import_textarea2
        });
        if (res.data.status !== 200) {
          this.$message.error(res.data.message);
        } else {
          this.$message.success('录入成功');
          this.search(this.table_data.current);
          this.is_show_importModal = false;
          return;
        }
      }
    });
  }
  async confirmEditRemark() {
    const res = await this.$axios.put(`${API.edit_remark}/${this.remark_data.id}`, {
      column: 'description' + (this.remark_type == 1 ? '' : this.remark_type),
      value: this.remark_val
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
    } else {
      this.$message.success('编辑成功');
      this.is_show_remarkModal = false;
      this.search(this.table_data.current);
      // this.remark_data.description = this.remark_val;
      return;
    }
  }
  handleEditDescription(data: any, type: number) {
    this.edit_remark_title = '编辑任务备注' + type;
    switch (type) {
      case 1:
        this.remark_data = data;
        this.remark_val = data.description;
        this.remark_type = type;
        this.is_show_remarkModal = true;
        break;
      case 2:
        this.remark_data = data;
        this.remark_val = data.description2;
        this.remark_type = type;
        this.is_show_remarkModal = true;
        break;
      case 3:
        this.remark_data = data;
        this.remark_val = data.description3;
        this.remark_type = type;
        this.is_show_remarkModal = true;
        break;
      case 4:
        this.remark_data = data;
        this.remark_val = data.description4;
        this.remark_type = type;
        this.is_show_remarkModal = true;
        break;
      case 5:
        this.remark_data = data;
        this.remark_val = data.description5;
        this.remark_type = type;
        this.is_show_remarkModal = true;
        break;
      default:
        break;
    }
  }
  // lee 新增任务备注2
  async confirmEditRemark2() {
    const res = await this.$axios.put(`${API.edit_remark}/${this.remark_data2.id}`, {
      column: 'description2',
      value: this.remark_val2
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
    } else {
      this.$message.success('编辑成功');
      this.is_show_remarkModal2 = false;
      this.remark_data2.description2 = this.remark_val2;
      return;
    }
  }
  // handleEditDescription2(data: any) {
  //    this.remark_data2 = data;
  //   this.remark_val2 = this.remark_data2.description2;
  //   this.is_show_remarkModal2 = true;
  // }
  handleTagChange(value: any) {
    this.form.tag_id = value;
  }
  async initCustomList() {
    const res = await this.$axios.get(`${API.custom_list}?temporary_id=${this.$route.params.id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    if (res.data.data) {
      // console.error(res.data.data);

      // res.data.data.forEach((item: any) => {
      //   item.value = item.type === 2 ? '全部' : '';
      // });
      this.custom_list = res.data.data;
      this.custom_more_change_list = JSON.parse(JSON.stringify(res.data.data));
      console.error(this.custom_list);
    }
  }
  beforeCreate() {
    this.more_form = this.$form.createForm(this);
    this.import_form = this.$form.createForm(this);
  }
  async created() {
    this.getMenuId();
    this.title = '' + this.$route.query.title;
    this.mission_id = +this.$route.params.id;
    this.getTemporary();
    const teacher_send_data = {
      weixin_nickname: '',
      charge: '',
      current: 1,
      page: 999999999
    };
    const teacher_url = getUrl(API.teacher_get_list, teacher_send_data);
    const teacher_res: any = await this.$axios.get(teacher_url);
    if (teacher_res.status === 200) {
      // this.teacher_table_data = teacher_res.data.data.detail ? teacher_res.data.data.detail : [];
      this.teacher_table_data = teacher_res.data.data ? teacher_res.data.data : [];
      this.teacher_table_data_change = teacher_res.data.data ? teacher_res.data.data : [];
      this.teacher_table_data = [
        {
          id: 0,
          weixin_nickname: '全部'
        },
        ...this.teacher_table_data
      ];
    }
    const tag_send_data = {
      weixin_nickname: '',
      charge: '',
      current: 1,
      page: 999999999
    };
    const tag_url = getUrl(API.tag_get_list, tag_send_data);
    const tag_res: any = await this.$axios.get(tag_url);
    // console.error(tag_res);

    if (tag_res.status === 200) {
      this.tag_table_data = tag_res.data.data ? tag_res.data.data : [];
      this.tag_table_data.forEach((element: any) => {
        if (element.parent.length) {
          element.parent.forEach((item: any) => {
            if (!item.parent.length) delete item.parent;
          });
        }
        if (!element.parent.length) delete element.parent;
      });
      //console.error();

      // this.tag_table_data = [{ id: 0, tag_name: '全部' }, ...this.tag_table_data];
      // this.tag_table_data = this.tag_table_data;

      this.ai_tag_list = this.readAiTagList(this.tag_table_data);
    }
    await this.initCustomList();
    this.search(1);
  }

  readAiTagList(tree: any) {
    const result: any[] = [];
    tree.forEach((item: any) => {
      const newItem = { ...item };
      if (item.parent) {
        newItem.parent = this.readAiTagList(item.parent);
      }
      if (item.is_ai || newItem.parent?.length > 0) {
        result.push(newItem);
      }
    });
    return result;
  }

  handleShowFeildsModal(item: any) {
    this.feilds_form = this.$form.createForm(this);
    this.choose_list_item = JSON.parse(JSON.stringify(item));
    this.is_show_feildsModal = true;
  }
  confirmFeildsData() {
    const promise_item: any[] = [];
    console.log(this.choose_list_item);
    this.choose_list_item.custom.forEach((element: any) => {
      promise_item.push(
        new Promise((ress, reject) => {
          // const res = await this.$axios.post(API.edit_custom, {
          //   temporary_user_id: element.temporary_user_id,
          //   custom_name_id: element.custom_name_id,
          //   custom_value: element.custom_value,
          // })
          // if(res.data.status !== 200) {
          //   this.$message.error(res.data.message);
          //   reject(res.data.message);
          //   return;
          // }
          // ress('111');
          this.$axios
            .post(API.edit_custom, {
              temporary_user_id: this.choose_list_item.id,
              custom_name_id: element.custom_name_id,
              custom_value: element.custom_value
            })
            .then((res) => {
              if (res.data.status !== 200) {
                this.$message.error(res.data.message);
                reject(res.data.message);
                return;
              }
              ress('111');
            });
        })
      );
    });
    // const a = new Promise((res, rej) => {
    //   this.$axios.post(API.edit_custom, {
    //     temporary_user_id: '',
    //     custom_name_id: '',
    //     custom_value: '',
    //   })
    // })
    Promise.all(promise_item).then((res: any) => {
      this.$message.success('编辑成功');
      this.search(this.table_data.current);
      this.is_show_feildsModal = false;
    });
    // this.feilds_form.validateFields(async (err: any, values: any) => {
    //   if(!err) {
    //     // const res = await this.$axios.post(API.edit_custom, {
    //     // })
    //   }
    //   console.log(err);
    //   console.log(this.feilds_form.getFieldsValue());
    // })
  }
  show_tag_teacherDetail_value() {
    if (this.is_show_tag_teacherDetail === false) {
      this.is_show_tag_teacherDetail = true;
    } else {
      this.is_show_tag_teacherDetail = false;
    }
  }
  // menu_id更改
  async getMenuId() {
    const { data }: any = await client.get(`${API.product_menu}?product_code=hundun`);
    this.user_list_id = data.menu_list[1].id;
  }
  //获取任务
  async getTemporary() {
    const res = await this.$axios.get(`${API.temporary}/${this.mission_id}?menu_id=${(window as any).route_menu_id}`);
    if (res.data.status !== 200) return this.$message.error('任务获取失败！');
    this.temporary = res.data.data;
    this.description_number = res.data.data.descriptionnumber;
  }
  async addRemark() {
    if (this.description_number >= 5) {
      return this.$message.warn('不能新增，上限为5！');
    }
    const res = await this.$axios.put(API.add_description_number + '/' + this.mission_id);
    if (res.status != 200 && res.data.status != 200) return this.$message.error('新增失败！');
    this.$message.success('新增成功！');
    this.is_show_description_modal = false;
    this.search(this.table_data.current);
    this.getTemporary();
  }
  // 添加任务备注
  addRemarkbtn() {
    this.is_show_description_modal = true;
  }
  showCreatModal() {
    this.upload_visible = true;
  }
  readExcel(sheet_data: any) {
    const ref: any = sheet_data['!ref'];
    const right_string: string = ref.split(':')[1];
    const max_number = right_string.replace(/[^0-9]/gi, '');
    const arr: any = [];
    for (let index = 2; index <= Number(max_number); index++) {
      const obj = JSON.parse(
        JSON.stringify({
          name: sheet_data['A' + index] ? sheet_data['A' + index].v : '',
          mobile: sheet_data['B' + index] ? sheet_data['B' + index].v.toString() : '',
          description: sheet_data['C' + index] ? sheet_data['C' + index].v : '',
          description2: sheet_data['D' + index] ? sheet_data['D' + index].v : '',
          description3: sheet_data['E' + index] ? sheet_data['E' + index].v : '',
          description4: sheet_data['F' + index] ? sheet_data['F' + index].v : '',
          description5: sheet_data['G' + index] ? sheet_data['G' + index].v : ''
        })
      );
      arr.push(obj);
    }
    this.upload_file = arr;
  }
  async uploadOk() {
    const send_data = {
      temporary_id: this.mission_id,
      list: this.upload_file
    };
    const res = await this.$axios.post(`${FCAPI}/boss/hundun/work/temporary/user/batch?menu_id=${(window as any).route_menu_id}`, send_data);
    if (res.data.status !== 200) return this.$message.error('导入失败');
    this.$message.success('导入成功!');
    this.upload_visible = false;
  }
  uploadCancel() {
    this.upload_visible = false;
  }
  downloadTemplate() {
    const output = Object.assign({}, this.header);
    const ref = 'A1:M1';
    const wb = {
      SheetNames: ['临时任务表模板'],
      Sheets: {
        临时任务表模板: Object.assign({}, output, { '!ref': ref })
      }
    };
    XLSX.writeFile(wb, '临时任务表模板.xlsx');
  }
}
